import React from 'react';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Detecta',
    desc: 'Identifica partidos con potencial real y descarta apuestas sin valor desde el inicio.'
  }, {
    num: '02',
    title: 'Analiza',
    desc: 'Evalúa cada jugada con lógica: estadísticas, contexto y criterios claros.'
  }, {
    num: '03',
    title: 'Ejecuta',
    desc: 'Aplica solo cuando hay ventaja real y evita decisiones impulsivas.'
  }];
  return <section className="w-full py-24 px-4 bg-brand-alt border-y border-brand-card" data-id="element-108">
      <div className="max-w-5xl mx-auto" data-id="element-109">
        <h2 className="text-4xl md:text-5xl text-center text-brand-gold mb-16" data-id="element-110">
          Cómo funciona BetIQ
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-111">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-brand-card border-t border-dashed border-brand-gold/30 z-0" data-id="element-112" />

          {steps.map((step, i) => <div key={i} className="relative z-10 flex flex-col items-center text-center" data-id="element-113">
              <div className="w-24 h-24 rounded-full bg-brand-bg border-2 border-brand-gold flex items-center justify-center mb-6 shadow-[0_0_15px_rgba(212,168,67,0.2)]" data-id="element-114">
                <span className="font-heading font-bold text-3xl text-brand-gold" data-id="element-115">
                  {step.num}
                </span>
              </div>
              <h3 className="text-2xl text-brand-text mb-3" data-id="element-116">{step.title}</h3>
              <p className="text-brand-muted text-lg" data-id="element-117">{step.desc}</p>
            </div>)}
        </div>

        <p className="text-center text-xl md:text-2xl text-brand-text font-medium mt-14" data-id="element-118">
          Un sistema simple. Sin adivinar. Sin depender de otros.
        </p>
      </div>
    </section>;
}